export default class ExtentHistory {
  history = null;
  historyCount = 0;
  historyIndex = -1;
  mapViewRef = null;
  updateByThisClass = false;
  lastTimer = 0;
  mapExtentObjKey = null;

  constructor() {
    this.history = new Array();
    window.extentHistory = this;
  }

  updateMapView(mapViewRef) {
    this.mapViewRef = mapViewRef;
    this.history.length = 0;
    this.historyCount = 0;
    this.historyIndex = -1;
    this.mapExtentObjKey = mapViewRef.type == "2d" ? "extent" : "camera";
    mapViewRef.watch(
      this.mapExtentObjKey,
      this.mapExtentUpdateHandler.bind(this)
    );
  }

  mapExtentUpdateHandler(newV, oldV) {
    clearTimeout(this.lastTimer);

    this.lastTimer = setTimeout(
      (() => {
        if (this.updateByThisClass) {
          this.updateByThisClass = false;
          console.debug(
            this.history,
            "count",
            this.historyCount,
            "index",
            this.historyIndex
          );
          return;
        }
        this.historyIndex++;
        this.history[this.historyIndex] = this.mapViewRef[this.mapExtentObjKey];
        this.historyCount = this.historyIndex + 1;
        console.debug(
          this.history,
          "count",
          this.historyCount,
          "index",
          this.historyIndex
        );
      }).bind(this),
      500
    );
  }

  previousExtent() {
    if (this.historyIndex != 0) {
      this.mapViewRef.goTo(this.history[--this.historyIndex], {
        animate: false,
      });
      this.updateByThisClass = true;
    }
  }

  nextExtent() {
    if (this.historyIndex != this.historyCount - 1) {
      this.mapViewRef[this.mapExtentObjKey] = this.history[++this.historyIndex];
      this.updateByThisClass = true;
    }
  }
}
